<section class="section1">
  <div class="row">
    <div class="col-md-1" style="background-color: #0055a4"></div>
    <div class="col-md-10">
      <div class="p-5">
        <div>
          <h1><b>Run virtual races across France</b></h1>
        </div>
        <img src="../assets/images/tour.png" style="width: 100px" />
        <div>
          <h2>
            Validate the challenges and receive <b>5</b> postcards from
            <b>5</b> French cities
          </h2>
        </div>
        <img src="../assets/images/louvre.png" style="width: 100px" />
        <div>
          <h3>
            Finish the adventure to unlock your final <b>postcard medal</b>
          </h3>
        </div>
        <div><h5>Put on your beret, take your baguette and join us</h5></div>
        <!-- <div><a type="button" href="#/register" class="btn btn-primary btn-lg">Click here to register and start the adventure</a></div> -->
      </div>
    </div>
    <div class="col-md-1" style="background-color: #ef4135"></div>
  </div>
</section>
<section class="section2">
  <h2 class="p-2">See how it works</h2>
  <video controls style="max-height: 320px; max-width: 100%">
    <source src="../../assets/videos/explain.mp4" type="video/mp4" />
    Sorry, your browser doesn't support embedded videos.
  </video>
</section>
<section class="section2">
  <div class="container p-5">
    <h2 class="p-2">How to start virtual running</h2>
    <div class="row">
      <div class="col-md-3 mb-2">
        <div class="box" style="border: 1px solid lightgray; height: 320px">
          <div>
            <img src="../assets/images/step1.png" style="width: 100px" />
          </div>
          <div>
            <h4><b>Register</b></h4>
          </div>
          <div>
            <h5>
              Register to VirtualRacesFrance and run it anywhere, anytime, with
              anyone – at your own pace.
            </h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="box" style="border: 1px solid lightgray; height: 320px">
          <div>
            <img src="../assets/images/step2.png" style="width: 100px" />
          </div>
          <div>
            <h4><b>Submit your results online</b></h4>
          </div>
          <div>
            <h5>
              Save your activitys online or use Strava connect to automatically
              sync your runs.
            </h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="box" style="border: 1px solid lightgray; height: 320px">
          <div>
            <img src="../assets/images/step3.png" style="width: 100px" />
          </div>
          <div>
            <h4><b>Receive 5 postcards</b></h4>
          </div>
          <div>
            <h5>
              Every time you finish all the challenges of a city you receive a
              postcard from France.
            </h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="box" style="border: 1px solid lightgray; height: 320px">
          <div>
            <img src="../assets/images/step4.png" style="width: 100px" />
          </div>
          <div>
            <h4><b>Receive 1 postcard medal</b></h4>
          </div>
          <div>
            <h5>At the end of the adventure you receive a postcard medal.</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section2">
  <div class="container p-5" style="display: inline-block">
    <div class="row">
      <h2 class="col md-12 p-2">Which cities will I visit ?</h2>
    </div>
    <div class="row m-2">
      <div class="col-md-6 align-self-center">
        <img class="imgCity" src="../../assets/images/Paris-min.jpeg" />
      </div>
      <div class="col-md-6 align-self-center">
        <h4>Paris</h4>
        <h6>The Arc de Triomphe (10k)</h6>
        <h6>Saint-Michel – Notre-Dame (10k)</h6>
        <h6>Louvre Museum (10k)</h6>
        <h6>Eiffel Tower (10k)</h6>
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-6 align-self-center">
        <img class="imgCity" src="../../assets/images/Marseille-min.jpeg" />
      </div>
      <div class="col-md-6 align-self-center">
        <h4>Marseille</h4>
        <h6>Old Port of Marseille (3mi)</h6>
        <h6>Le panier (10k)</h6>
        <h6>Basilica of Our Lady of the Guard (10k)</h6>
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-6 align-self-center">
        <img class="imgCity" src="../../assets/images/Nice-min.jpeg" />
      </div>
      <div class="col-md-6 align-self-center">
        <h4>Nice</h4>
        <h6>The Promenade des Anglais (10mi)</h6>
        <h6>The Vieux Nice (Old town) (10k)</h6>
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-6 align-self-center">
        <img class="imgCity" src="../../assets/images/Bordeaux-min.jpeg" />
      </div>
      <div class="col-md-6 align-self-center">
        <h4>Bordeaux</h4>
        <h6>Vineyard of Bordeaux (10k)</h6>
        <h6>The Miroir d'eau (Water Mirror) (10k)</h6>
        <h6>Dune of Pilat (10k)</h6>
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-6 align-self-center">
        <img class="imgCity" src="../../assets/images/Versailles-min.jpeg" />
      </div>
      <div class="col-md-6 align-self-center">
        <h4>Versailles</h4>
        <h6>Palace of Versailles (10k)</h6>
        <h6>Gardens of Versailles (10k)</h6>
      </div>
    </div>
  </div>
</section>
<section class="section3">
  <div class="container p-5">
    <div class="accordion" id="accordionExample">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h2 class="mb-0">
            <button
              class="btn btn-link"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <h5>What is a virtual challenge?</h5>
            </button>
          </h2>
        </div>

        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            <h5>
              A virtual challenge can be done from any location you choose. You
              can run, jog, walk, cycle, swim, use a wheelchair - whatever you
              choose and however you choose to complete a distance. There is no
              restriction on discipline. We aim to be as inclusive as
              impossible.
            </h5>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h2 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              <h5>How many postcard will I receive ?</h5>
            </button>
          </h2>
        </div>
        <div
          id="collapseTwo"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            <h5>
              You will receive 6 postcards, 1 from Paris, 1 from Marseille, 1
              from Nice, 1 from Bordeaux, 1 from Nice and 1 postcard medal at
              the end of the adventure.
            </h5>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h2 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h5>How long is delivery?</h5>
            </button>
          </h2>
        </div>
        <div
          id="collapseThree"
          class="collapse"
          aria-labelledby="headingThree"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            <h5>
              All postcards are dispatched within 1-2 days after you finished
              all the challenges of a city.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="section2">
  <div class="container p-5">
    <h2 class="p-2">Register to start the adventure</h2>
    <a type="button" href="#/register" class="btn btn-primary btn-lg">Click here to register and start the adventure</a>
  </div>
</section> -->
